import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

import { PaymentLogTypes } from '../../form-common/types/PaymentFormLogTypes'

export const PaymentMarkName = {
  GoToPaymentClicked: 'go_to_payment_page_clicked',
  [PaymentLogTypes.FORM_DISPLAY]: 'payment_form_displayed',
  [PaymentLogTypes.FORM_SETUP_SUCCESS]: 'payment_form_setup_success',
} as const
// eslint-disable-next-line no-redeclare
export type PaymentMarkName = UnionOfPropertyTypes<typeof PaymentMarkName>

export const PaymentMeasure: [
  name: string,
  start: PaymentMarkName,
  end: PaymentMarkName,
][] = [
  [
    // Payment Page Navigation to Form Displayed
    // https://backmarket.atlassian.net/wiki/spaces/PAYIN/pages/4952359008/Full+payment+pages+isolation#Payment-Page-Navigation-to-Form-Displayed
    'payment_page_navigation_to_form_displayed',
    PaymentMarkName.GoToPaymentClicked,
    PaymentMarkName[PaymentLogTypes.FORM_DISPLAY],
  ],
  [
    // Payment Page Navigation to Form Interactive
    // https://backmarket.atlassian.net/wiki/spaces/PAYIN/pages/4952359008/Full+payment+pages+isolation#Payment-Page-Navigation-to-Form-Interactive
    'payment_page_navigation_to_form_interactive',
    PaymentMarkName.GoToPaymentClicked,
    PaymentMarkName[PaymentLogTypes.FORM_SETUP_SUCCESS],
  ],
]
